import { ENV_CONFIG } from 'config/environment';

export const AUTOPILOT_CLIENT_ID = 182;

export const pageTypeButtons = [
  {
    type: 'donate',
    img: `${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/donation-page.jpg`,
    title: 'Donation Page',
    description: 'Drive action to 1 main cause/issue',
  },
  {
    type: 'event',
    img: `${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/event-page.jpg`,
    title: 'Event Page',
    description: 'Host a fundraising event',
  },
  {
    type: 'recommendation',
    img: `${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/recommendation-page.jpg`,
    title: 'Recommendation Page',
    description: 'Curate a list of recommended orgs',
  },
  {
    type: 'community',
    img: `${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/community-page.jpg`,
    title: 'Community Page',
    description: 'Drive action to multiple issues',
  },
];

export const pageTypes = {
  donate: ['Donation Page Design', 'Donation Options', 'Page Options', 'Community Card Design'],
  event: [
    'Event Page Design',
    'Donation Ticket Options',
    'Donation Options',
    'Page Options',
    'Community Card Design',
  ],
  recommendation: [
    'Recommendation Page Design',
    'Recipient Options',
    'Donation Options',
    'Page Options',
    'Community Card Design',
  ],
  community: ['Community Page Design', 'Page Options', 'Community Sections'],
};

export const checksTab = {
  donate: [
    ['page_name', 'query_string'],
    [
      'donation_amounts',
      'recipient_groups',
      'offline_instructions_wire',
      'offline_instructions_check',
      'offline_instructions_grant',
    ],
    ['paused_description', 'paused_redirect_button', 'paused_redirect_url', 'recurring_interval'],
    ['display_fundraising_bar', 'fundraising_goal', 'learn_more_link'],
  ],
  event: [
    [
      'page_name',
      'subdescription',
      'query_string',
      'location',
      'doors_open_datetime',
      'start_time',
      'end_time',
      'event_date',
    ],
    ['rows'],
    [
      'recipient_groups',
      'offline_instructions_wire',
      'offline_instructions_check',
      'offline_instructions_grant',
    ],
    ['paused_description', 'paused_redirect_button', 'paused_redirect_url'],
    ['display_fundraising_bar', 'fundraising_goal', 'learn_more_link'],
  ],
  recommendation: [
    ['page_name', 'query_string'],
    [],
    ['offline_instructions_wire', 'offline_instructions_check', 'offline_instructions_grant'],
    ['paused_description', 'paused_redirect_button', 'paused_redirect_url'],
    ['display_fundraising_bar', 'fundraising_goal'],
  ],
  community: [['querystring'], ['set_pages'], []],
};

export const whiteLabelNavigationOptions = [
  { label: 'Show', value: 'FALSE' },
  { label: 'Hide', value: 'TRUE' },
];
export const displayFundraisingBarOptions = [
  { label: 'Show', value: 'TRUE' },
  { label: 'Hide', value: 'FALSE' },
];

export const recurringIntervalOptions = [
  { label: 'Weekly', value: 'week' },
  { label: 'Monthly', value: 'month' },
  { label: 'Quarterly', value: 'quarter' },
  { label: 'Yearly', value: 'year' },
];

// Default values that match what `getInitialValues` returns for a brand-new
// page (lines 21–78 of utils.tsx). These must stay in sync with the backend's
// `assert_permission_to_set_fields` expected defaults.
//
// `processing_redirect` is special: its default comes from
// `clientPages.preferred_payment_processor`, so it's handled separately in
// resetRestrictedFields.

export const RESTRICTED_FIELD_DEFAULTS: Record<string, any> = {
  is_public_searchable: false,
  whitelabeled: false,
  is_oath_disclaimer_visible: true,
  recurring_enabled: false,
  recurring_interval: null,
};

export const RESTRICTED_FIELD_LABELS: Record<string, string> = {
  is_public_searchable: 'Public Searchable',
  whitelabeled: 'Whitelabeled',
  is_oath_disclaimer_visible: 'Oath Disclaimer Visibility',
  processing_redirect: 'Processing Redirect',
  recurring_enabled: 'Recurring Donations',
  recurring_interval: 'Recurring Interval',
};
